import type { SupportReportCategory, SupportReportSeverity } from "../types";

export const SUPPORT_EMAIL_HONEYPOT_FIELD = "website";
export const SUPPORT_EMAIL_MIN_AGE_MS = 2500;

export type SupportEmailSubmission = {
  reportId: string;
  summary: string;
  details: string;
  category: SupportReportCategory;
  severity: SupportReportSeverity;
  pagePath: string;
  pageUrl: string;
  businessName: string;
  planId: string;
  activeAiProvider: string;
  appVersion: string;
  sentryEventId?: string | null;
  openedAt: string;
  [SUPPORT_EMAIL_HONEYPOT_FIELD]?: string;
};

export type SupportEmailApiResponse = {
  ok: true;
  messageId?: string;
} | {
  ok: false;
  error: string;
};

export async function sendSupportEmail(submission: SupportEmailSubmission, idToken: string) {
  const response = await fetch("/api/support-email", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(submission),
  });

  const payload = (await response.json().catch(() => null)) as SupportEmailApiResponse | null;

  if (!response.ok || !payload || payload.ok === false) {
    const errorMessage = payload && payload.ok === false ? payload.error : `Support email request failed (${response.status})`;
    throw new Error(errorMessage);
  }

  return payload;
}
